import { useEffect } from 'react';
import { trackPendoEvent } from 'src/helpers/trackPendoEvent';
import { ViewerMode } from '../components/ViewerModePill';

export type TrackedMode = ViewerMode | 'text_boxes_page' | 'text_boxes_lines';

export const useViewerModeTime = (mode: TrackedMode, enabled: boolean, surface?: string) => {
  useEffect(() => {
    if (!enabled) return undefined;
    let startedAt: number | null = document.visibilityState === 'hidden' ? null : Date.now();

    const flush = () => {
      if (startedAt === null) return;
      const seconds = Math.round((Date.now() - startedAt) / 1000);
      startedAt = null;
      if (seconds < 1) return;
      trackPendoEvent('viewer_mode_time', surface ? { mode, seconds, surface } : { mode, seconds });
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'hidden') flush();
      else if (startedAt === null) startedAt = Date.now();
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      flush();
    };
  }, [mode, enabled, surface]);
};
